import React, { Component } from 'react'
import PropTypes from 'prop-types'
import css from './blasts.css'

const Patient = ({ patient }) => (
  <span className={css.patient}>
    {`${patient.first_name} ${(patient.last_name)}`}
  </span>
)

Patient.propTypes = {
  patient: PropTypes.shape({
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
  }),
}

const BlastMessagesHeader = ({ patients, blastFilter }) => (
  <div className={css.container}>
    {blastFilter === 'all' ?
      <span className={css.patient}>
        All Listed Patients
      </span> :
      patients.map(patient => (
        <Patient
          key={patient.id}
          patient={patient}
        />
      ))}
  </div>
)

BlastMessagesHeader.propTypes = {
  patients: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  blastFilter: PropTypes.string,
}

export default BlastMessagesHeader



// WEBPACK FOOTER //
// ./src/components/Messages/Header/BlastMessagesHeader.js